import { render, staticRenderFns } from "./EModalRemanejarMatricula.vue?vue&type=template&id=1c8ac25c&scoped=true"
import script from "./EModalRemanejarMatricula.vue?vue&type=script&lang=js"
export * from "./EModalRemanejarMatricula.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8ac25c",
  null
  
)

export default component.exports